const sendAnalytic = (category, name, variant = '') => {
    if (typeof window.gtag !== 'function') {
        return;
    }

    window.gtag('event', 'purchase', {
        value: 10,
        currency: 'NTD',
        items: [{
            item_category: category,
            item_name: name,
            item_variant: variant
        }]
    });
};

export default sendAnalytic;
